// Shared JavaScript
let html = document.getElementsByTagName('html')[0];

// // Age verification
// var agefilter = localStorage.getItem('agefilter');
// var ageYes = document.getElementsByClassName('age-yes')[0];

// if (agefilter == null) {
//   document.documentElement.classList.add('age-filter');
// }

// ageYes.onclick = function() {
//   document.documentElement.classList.remove('age-filter'); 
//   localStorage.setItem('agefilter', 1);
//   console.log("This should work");
// };

// Mobile navigation
// Mobile navigation
var mobileNavToggles = document.querySelectorAll('.mobile-nav-trigger-button');
var header = document.querySelector('.global-header');

mobileNavToggles.forEach(function(toggle) {
  toggle.onclick = function() {
    html.classList.toggle('mobile-menu-open');
  }
});

// Navigation blackout effect
var childLinkNav = document.querySelector('.has-child-links');
var blackout = document.querySelector('.nav-blackout')
childLinkNav.addEventListener('mouseover', changeDefOver);
childLinkNav.addEventListener('mouseout', changeDefOut);
blackout.addEventListener('mouseover', removeBlackout);

function changeDefOver(e) {
  html.classList.toggle('nav-blackout-enabled');
}

function changeDefOut(e) {
  html.classList.toggle('nav-blackout-enabled');
}

function removeBlackout(e) {
  html.classList.remove('nav-blackout-enabled');
}


// Accordions
var accItem = document.getElementsByClassName('accordion');
var accHD = document.getElementsByClassName('accordion-toggle');
for (i = 0; i < accHD.length; i++) {
    accHD[i].addEventListener('click', toggleItem, false);
    // role="button" is not natively operable: a div gets no free Enter/Space
    // activation, so wire it up by hand. WCAG 2.1.1 Keyboard.
    accHD[i].addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
            event.preventDefault();
            toggleItem.call(this);
        }
    });
}
function toggleItem() {
    var itemClass = this.parentNode.className;
    for (i = 0; i < accItem.length; i++) {
        accItem[i].className = 'accordion closed';
    }
    if (itemClass == 'accordion closed') {
        this.parentNode.className = 'accordion open';
    }
    syncAccordionState();
}
// Keep the announced state in step with the visual state, for every toggle --
// one click closes all the others, so they all need re-syncing.
function syncAccordionState() {
    for (i = 0; i < accHD.length; i++) {
        accHD[i].setAttribute(
            'aria-expanded',
            accHD[i].parentNode.className.indexOf('open') !== -1 ? 'true' : 'false'
        );
    }
}

// Swiper sliders
var sliderProductImages = new Swiper('.swiper-product-images', {
  speed: 400,
  autoplay: true,
  slidesPerView: 'auto',
  slidesPerGroup: 1,
  spaceBetween: 8,
  centeredSlidesBounds: true,
});

var sliderProducts = new Swiper('.swiper-product-slider', {
  speed: 400,
  autoplay: true,
  slidesPerView: 2,
  spaceBetween: 8,
  breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 12
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 16
      }
    }
});

var sliderPress = new Swiper('.swiper-press-slider', {
  speed: 400,
  autoplay: true,
  slidesPerView: 1,
  spaceBetween: 8,
  breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 12
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 16
      }
    }
});

var sliderPressLogos = new Swiper('.subsection-press-slider', {
  speed: 400,
  autoplay: true,
  slidesPerView: 2,
  spaceBetween: 0,
  breakpoints: {
      768: {
        slidesPerView: 4,
        spaceBetween: 12
      }
    }
});

var sliderUGC = new Swiper('.ugc-swiper', {
  speed: 400,
  autoplay: true,
  slidesPerView: 2,
  spaceBetween: 8,
  breakpoints: {
      768: {
        slidesPerView: 4,
        spaceBetween: 12
      }
    }
});

// Quantity selector
const quantity_input = document.querySelector("#product-form").querySelector('input[name="quantity"]');
const quantity_selector = document.getElementsByClassName('quantity-selector-option');
for (q = 0; q < quantity_selector.length; q++) {
  quantity_selector[q].addEventListener('click', changeQuantity, false);
  // Same as the accordion: role="button" on a div needs Enter/Space by hand.
  quantity_selector[q].addEventListener('keydown', function (event) {
    if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
      event.preventDefault();
      changeQuantity.call(this);
    }
  });
}
syncQuantityState();

function changeQuantity() {
  var quantityValue = this.dataset.value;
  quantity_input.value = quantityValue;

  for (q = 0; q < quantity_selector.length; q++) {
    quantity_selector[q].classList.remove('quantity-active');
  }
  this.classList.add("quantity-active");
  syncQuantityState();
}

// Which pack is selected is conveyed only by a class and colour otherwise --
// aria-pressed is what carries it to a screen reader.
function syncQuantityState() {
  for (q = 0; q < quantity_selector.length; q++) {
    quantity_selector[q].setAttribute(
      'aria-pressed',
      quantity_selector[q].classList.contains('quantity-active') ? 'true' : 'false'
    );
  }
}

// Custom Quickie quantity selector
// This ensures the increment/decrement buttons update the visible value and the hidden input

document.addEventListener('DOMContentLoaded', function() {
  var qtyDecrement = document.querySelector('.qty-decrement');
  var qtyIncrement = document.querySelector('.qty-increment');
  var qtyValue = document.getElementById('custom-qty-value');
  var qtyInput = document.querySelector('#product-form input[name="quantity"]');

  if (qtyDecrement && qtyIncrement && qtyValue && qtyInput) {
    qtyDecrement.addEventListener('click', function() {
      var current = parseInt(qtyValue.textContent, 10);
      if (current > 1) {
        qtyValue.textContent = current - 1;
        qtyInput.value = current - 1;
      }
    });
    qtyIncrement.addEventListener('click', function() {
      var current = parseInt(qtyValue.textContent, 10);
      qtyValue.textContent = current + 1;
      qtyInput.value = current + 1;
    });
    // Sync input changes (if user types in input directly)
    qtyInput.addEventListener('input', function() {
      var val = parseInt(qtyInput.value, 10);
      if (!isNaN(val) && val > 0) {
        qtyValue.textContent = val;
      }
    });
  }
});

window.addEventListener("scroll", function() {
  var elementTarget = document.getElementById("pdp-main");
  if (window.scrollY > (elementTarget.offsetTop + elementTarget.offsetHeight)) {
    html.classList.add('pdp-bar-on');
  } else {
    html.classList.remove('pdp-bar-on');
  }
});